import InspectionRequestPreference from "./InspectionRequestPreference";
import { CalendarDate, isEqualDay, isEqualMonth, isEqualYear } from "@internationalized/date";

export default class InspectionRequestPreferences {
  private preferences: InspectionRequestPreference[];

  constructor(preferences: { date: CalendarDate; meridiem: "AM" | "PM" | null }[]) {
    this.preferences = preferences.map((pref) => {
      return new InspectionRequestPreference(pref.date, pref.meridiem);
    });
  }

  isFirstPreference(date: CalendarDate): boolean {
    return this.isPreferredDate(1, date);
  }

  isSecondPreference(date: CalendarDate): boolean {
    return this.isPreferredDate(2, date);
  }

  isThirdPreference(date: CalendarDate): boolean {
    return this.isPreferredDate(3, date);
  }

  hasAMPreference(date: CalendarDate): boolean {
    return this.preferences.some((preference) => {
      return this.dateYearMonthDayEqual(date, preference.date) && preference.hasAmPreference();
    });
  }

  hasPMPreference(date: CalendarDate): boolean {
    return this.preferences.some((preference) => {
      return this.dateYearMonthDayEqual(date, preference.date) && preference.hasPmPreference();
    });
  }

  private isPreferredDate(preference: number, date: CalendarDate): boolean {
    const preferenceObject = this.getPreference(preference);
    if (preferenceObject === null) {
      return false;
    }

    return this.dateYearMonthDayEqual(date, preferenceObject.date);
  }

  private getPreference(preference: number): InspectionRequestPreference | null {
    if (this.preferences.length < preference) {
      return null;
    }
    return this.preferences[preference - 1];
  }

  private dateYearMonthDayEqual(date: CalendarDate, other: CalendarDate): boolean {
    return isEqualDay(date, other) && isEqualMonth(date, other) && isEqualYear(date, other);
  }
}
